
      import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
      setBasePath('/shoelace/');
    